import CommonStyles from 'shared/style/commonPageStyles'
import styled, {css} from 'styled-components'

const Style = {
	Wrapper: CommonStyles.PageWrapper,
	AreaDiv: CommonStyles.AreaDiv,
	AreaHeader: CommonStyles.AreaHeader,
	Title: styled.h2`
		flex: 1;
		width: 100%;
	`,
	LogoImg: styled.img`
		height: 180px;
	`,

	Tab: styled.button`
		${({theme}) => theme.font.small_bold};

		${({$selected}) =>
			$selected &&
			css`
				${({theme}) => theme.font.small_bold};
				color: ${({theme}) => theme.color.major};
			`}
	`,
	Radio: styled.button`
		display: flex;
		align-items: center;
		gap: 8px;
	`,
}

export default Style
